// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.swal2-loader{
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border-color: #009188 rgba(0,0,0,0) #009188 rgba(0,0,0,0);
}


.swal2-container {
  z-index: 2000;
}`, "",{"version":3,"sources":["webpack://./src/css/swal.css"],"names":[],"mappings":";AACA;EACE,8DAA8D;EAC9D,yDAAyD;AAC3D;;;AAGA;EACE,aAAa;AACf","sourcesContent":["\n.swal2-loader{\n  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n  border-color: #009188 rgba(0,0,0,0) #009188 rgba(0,0,0,0);\n}\n\n\n.swal2-container {\n  z-index: 2000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
